import React from "react";
import {
  Box,
  Paper,
  Stack,
  Typography,
  ToggleButton,
  ToggleButtonGroup, TextAlignLeftIcon, TextAlignCenterIcon, TextAlignRightIcon, TextAlignJustifyCenterIcon,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const ToggleButtonSize = () => {
  const [alignment, setAlignment] = React.useState("left");

  const handleChange = (event, newAlignment) => {
    setAlignment(newAlignment);
  };

  const children = [
    <ToggleButton value="left" key="left">
      <TextAlignLeftIcon />
    </ToggleButton>,
    <ToggleButton value="center" key="center">
      <TextAlignCenterIcon />
    </ToggleButton>,
    <ToggleButton value="right" key="right">
      <TextAlignRightIcon />
    </ToggleButton>,
    <ToggleButton value="justify" key="justify">
      <TextAlignJustifyCenterIcon />
    </ToggleButton>,
  ];

  const control = {
    value: alignment,
    onChange: handleChange,
    exclusive: true,
  };

  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Size
        </Typography>
        <Typography variant={"body1"} color={"text.primary"}>
          For larger or smaller buttons, use the size prop.
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <PreviewAndEditor
            language={"js"}
            value={
              "const Index = () => {\n" +
              '  const [alignment, setAlignment] = React.useState("left");\n' +
              "\n" +
              "  const handleChange = (event, newAlignment) => {\n" +
              "    setAlignment(newAlignment);\n" +
              "  };\n" +
              "\n" +
                "const children = [\n" +
                "    <ToggleButton value=\"left\" key=\"left\">\n" +
                "      <TextAlignLeftIcon />\n" +
                "    </ToggleButton>,\n" +
                "    <ToggleButton value=\"center\" key=\"center\">\n" +
                "      <TextAlignCenterIcon />\n" +
                "    </ToggleButton>,\n" +
                "    <ToggleButton value=\"right\" key=\"right\">\n" +
                "      <TextAlignRightIcon />\n" +
                "    </ToggleButton>,\n" +
                "    <ToggleButton value=\"justify\" key=\"justify\">\n" +
                "      <TextAlignJustifyCenterIcon />\n" +
                "    </ToggleButton>,\n" +
                "  ];"+
              "\n" +
              "  const control = {\n" +
              "    value: alignment,\n" +
              "    onChange: handleChange,\n" +
              "    exclusive: true,\n" +
              "  };\n" +
              "\n" +
              "  return (\n" +
              '    <Stack spacing={2} alignItems="center">\n' +
              '      <ToggleButtonGroup size="small">\n' +
              "        {children}\n" +
              "      </ToggleButtonGroup>\n" +
              '      <ToggleButtonGroup >\n' +
              "        {children}\n" +
              "      </ToggleButtonGroup>\n" +
              '      <ToggleButtonGroup size="large" >\n' +
              "        {children}\n" +
              "      </ToggleButtonGroup>\n" +
              "    </Stack>\n" +
              "  );\n" +
              "};\n"
            }
          >
            <Stack spacing={2} alignItems="center">
              <ToggleButtonGroup size="small">{children}</ToggleButtonGroup>
              <ToggleButtonGroup>{children}</ToggleButtonGroup>
              <ToggleButtonGroup size="large">{children}</ToggleButtonGroup>
            </Stack>
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default ToggleButtonSize;
